import { defineMessages } from 'react-intl-next';

export default defineMessages({
	label: {
		id: 'roadmap.timeline-table.main.content.list.list-item.select-checkbox.label',
		defaultMessage: 'Row selection',
		description: 'Label for the select checkbox on each of the rows.',
	},
});
